import { ApplicationConfig, provideBrowserGlobalErrorListeners, provideZoneChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';

import { routes } from './app.routes';
import {provideHttpClient, withInterceptors} from '@angular/common/http';
import {authInterceptor} from "./auth/auth.interceptor";
import {MatPaginatorIntl} from '@angular/material/paginator';
import {AppMaterialPaginatorIntl} from '../core/services/material-paginator-intl.service';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideHttpClient(withInterceptors([authInterceptor])),
    {provide: MatPaginatorIntl, useClass: AppMaterialPaginatorIntl}
  ]
};
